"use client";
import { useState } from "react";
import { ExtraFeatureAnySetting } from "@/types/orderForm";
import { ExtraFeaturesSidebar } from "@/components/pages/blog/ai-article/components/ExtraFeaturesSidebar";
import { ArticleCategoriesSearchModal } from "@/components/pages/blog/ai-article/components/ArticleCategoriesSearchModal";

export type ArticleFAQSidebarProps = {
  articlesTotalCount: number;
  extraFeatures: ExtraFeatureAnySetting[];
};

export const ArticleFAQSidebar = ({ articlesTotalCount, extraFeatures }: ArticleFAQSidebarProps) => {
  const [modalVisible, setModalVisible] = useState(false);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      <ArticleCategoriesSearchModal
        articlesTotalCount={articlesTotalCount}
        visible={modalVisible}
        onVisibleChange={setModalVisible}
      />
      <ExtraFeaturesSidebar extraFeatures={extraFeatures} />
    </div>
  );
};
